import { List, Modal, Popover, Spin } from 'antd'
import React, { useCallback, useEffect, useState } from 'react'
import style from "css/address.module.css";
import { ReactComponent as Close } from "asset/common/close_popup.svg";
import { ReactComponent as Delete } from "asset/address/delete.svg";
import { MoreOutlined } from '@ant-design/icons';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

function TagPopup({ isOpen, refreshEvent, closeEvent, tagList }) {
    const { t } = useTranslation();
    return (
        <Modal
            open={isOpen}
            footer={[]}
            closable={false}
            width={300}
            zIndex={1000}
            centered
        >
            <div className={style.info_popup_container}>
                <div className={style.info_popup_header}>
                    <p className={style.info_popup_title}>
                        {t("LABEL.TITLE.CHANGE_TAG")}
                    </p>
                    <Close
                        className={style.info_popup_close}
                        onClick={() => closeEvent()}
                    />
                </div>

                <div className={style.tag_popup_container}>
                    <List
                        bordered
                        dataSource={tagList}
                        renderItem={(item) => (
                            <List.Item>
                                <div
                                    className={style.tag_popup_item}
                                    key={item.key}
                                >
                                    <div
                                        className={style.info_popup_select_item}
                                        style={{
                                            color: item.txt_color,
                                            backgroundColor: item.bg_color,
                                            fill: item.txt_color
                                        }}
                                    >
                                        {item.label}
                                    </div>

                                    <TagOption item={item} refreshEvent={refreshEvent} />
                                </div>
                            </List.Item>
                        )}
                    />
                </div>
            </div>
        </Modal>
    )
}

export default TagPopup

function TagOption({ item, refreshEvent }) {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState({});
    const [isSave, setIsSave] = useState(false);

    const saveEventHandler = useCallback(() => {
        setIsLoading(true);
        const axiosData = {
            key: data.key,
            label: data.label === "" ? item.label : data.label,
            txt_color: data.txt_color,
            bg_color: data.bg_color
        }

        axios.put("/address/tag", axiosData)
            .then(
                res => {
                    if (res.status === 200) {
                        refreshEvent();
                    }
                }
            )
            .finally(() => {
                setIsLoading(false);
            })
    }, [data.bg_color, data.key, data.label, data.txt_color, item.label, refreshEvent]);

    useEffect(() => {
        if (isSave) {
            saveEventHandler();
            setIsSave(false);
        }
    }, [isSave, saveEventHandler]);

    useEffect(() => {
        if (isOpen) {
            setData(item);
        }
    }, [isOpen, item]);

    const colorTemplate = [
        { txt_color: "#65a5e0", bg_color: "#dcedfc" },
        { txt_color: "#1cb691", bg_color: "#def5e9" },
        { txt_color: "#fd9800", bg_color: "#fef0d4" }
    ]

    const handleOpenChange = (newOpen) => {
        setIsOpen(newOpen);
    };

    const deleteEventHandler = () => {
        setIsLoading(true);
        const config = {
            params: {
                key: data.key
            }
        }

        axios.delete("/address/tag", config)
            .then(res => {
                if (res.status === 200) {
                    refreshEvent();
                }
            })
            .finally(() => {
                setIsLoading(false);
            })
    }



    const Content = () => {
        return (
            <section>
                <div
                    className={`${style.tag_delete_btn} cursor`}
                    onClick={() => deleteEventHandler()}
                >
                    {
                        isLoading
                            ?
                            <Spin />
                            :
                            <>
                                <Delete />
                                <p>{t("BTN.DELETE")}</p>
                            </>
                    }
                </div>

                {/* <Divider /> */}
                {/* <Input
                    value={data.label}
                    onKeyDown={
                        e => {
                            e.stopPropagation();
                            if (e.key === "Enter") {
                                setIsSave(true);
                            }
                        }
                    }
                    onChange={
                        e => {
                            e.stopPropagation();
                            setData({
                                ...data,
                                label: e.target.value
                            });
                        }
                    }
                /> */}

                <div className={style.tag_color_area}>
                    {
                        colorTemplate.map(
                            (el, idx) => (
                                <div
                                    className={`${style.info_popup_select_item} cursor`}
                                    style={{
                                        color: el.txt_color,
                                        backgroundColor: el.bg_color,
                                        fill: el.txt_color
                                    }}
                                    key={idx}
                                    onClick={
                                        () => {
                                            setData({
                                                ...data,
                                                txt_color: el.txt_color,
                                                bg_color: el.bg_color
                                            });
                                            setIsSave(true);
                                        }
                                    }
                                >
                                    {el.txt_color}
                                </div>
                            )
                        )
                    }
                </div>
            </section>
        )
    }

    return (
        <Popover
            placement="right"
            content={<Content />}
            arrow={false}
            trigger="click"
            open={isOpen}
            onOpenChange={handleOpenChange}
        >
            <MoreOutlined className='cursor' />
        </Popover>
    )
}